import { render, staticRenderFns } from "./read-more.vue?vue&type=template&id=a92f9fa0&scoped=true&"
import script from "./read-more.vue?vue&type=script&lang=js&"
export * from "./read-more.vue?vue&type=script&lang=js&"
import style0 from "./read-more.vue?vue&type=style&index=0&id=a92f9fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f9fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\paulj\\Documents\\MindArc\\retainer\\annathomas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a92f9fa0', component.options)
    } else {
      api.reload('a92f9fa0', component.options)
    }
    module.hot.accept("./read-more.vue?vue&type=template&id=a92f9fa0&scoped=true&", function () {
      api.rerender('a92f9fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/read-more.vue"
export default component.exports